import React, { useState, useCallback, useEffect } from "react";
import {
  getAuditStatusCount,
  getTEStatusCount,
  getDocumentStatusCount
} from "../../../services/DashboardService";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const [data, setData] = useState(null);
  const [teReport, setTEReport] = useState(null);
  const [audit, setAudit] = useState(null);
  const [document, setDocument] = useState(null);
  const [auditReport, setAuditReport] = useState(null);
  const navigate = useNavigate();


  
  const fetchAudit = useCallback(async () => {
    try {
      const resp = await getAuditStatusCount();
      setAudit(resp.data.audit_circular_counts);
      setAuditReport(resp.data.audit_report_counts);
    } catch (error) {
      console.error("Error fetching report:", error);
    }
  }, []);

  const fetchData = useCallback(async () => {
    try {
      const resp = await getTEStatusCount();
      setData(resp.data.sheet_status_counts);
      setTEReport(resp.data.te_report_status_counts);
      fetchAudit();
    } catch (error) {
      console.error("Error fetching audit data:", error);
      setData(null);
    }
  }, [fetchAudit]);

  const fetchDocument = useCallback(async () => {
    try {
      const resp = await getDocumentStatusCount();
      setDocument(resp.data.results);
      fetchData()
    } catch (error) {
      console.error("Error fetching report:", error);
    }
  }, [fetchData]); 

  useEffect(() => {
    fetchDocument();
  }, [fetchDocument]);

  return (
    <div class="container-fluid">

      <div class="row">
        <h3 className="text-primary">Documents Status</h3>
        <div class="col-md-6 col-lg-3">
          <div class="card border-0 ">
            <div class="card-body d-flex flex-column justify-content-between">
              <div>
                <h6 class="text-uppercase fw-bold text-muted mb-3">Pending</h6>
                <div class="d-flex justify-content-between align-items-center">
                  <h2 class="fw-bold text-warning">{document?.pending_count}</h2>
                  <button class="btn btn-warning btn-sm btn-circle" onClick={() => navigate("/document?status=pending")}>
                    <i class="bi bi-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-3">
          <div class="card border-0 ">
            <div class="card-body d-flex flex-column justify-content-between">
              <div>
                <h6 class="text-uppercase fw-bold text-muted mb-3">Reviewed</h6>
                <div class="d-flex justify-content-between align-items-center">
                  <h2 class="fw-bold text-info">{document?.reviewed_count}</h2>
                  <button class="btn btn-info btn-sm btn-circle" onClick={() => navigate("/document?status=pending")}>
                    <i class="bi bi-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3">
          <div class="card border-0 ">
            <div class="card-body d-flex flex-column justify-content-between">
              <div>
                <h6 class="text-uppercase fw-bold text-muted mb-3">Approved</h6>
                <div class="d-flex justify-content-between align-items-center">
                  <h2 class="fw-bold text-success">{document?.approved_count}</h2>
                  <button class="btn btn-success btn-sm btn-circle" onClick={() => navigate("/document?status=approved")}>
                    <i class="bi bi-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3">
          <div class="card border-0 ">
            <div class="card-body d-flex flex-column justify-content-between">
              <div>
                <h6 class="text-uppercase fw-bold text-muted mb-3">Issued</h6>
                <div class="d-flex justify-content-between align-items-center">
                  <h2 class="fw-bold text-primary">{document?.issued_count}</h2>
                  <button class="btn btn-primary btn-sm btn-circle" onClick={() => navigate("/document?status=issued")}>
                    <i class="bi bi-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>      
      
      
      <div class="row">
        <h3 className="text-primary">TE Measurement Sheets Status</h3>
        <div class="col-md-6 col-lg-3">
          <div class="card border-0 ">
            <div class="card-body d-flex flex-column justify-content-between">
              <div>
                <h6 class="text-uppercase fw-bold text-muted mb-3">Pending</h6>
                <div class="d-flex justify-content-between align-items-center">
                  <h2 class="fw-bold text-warning">{data?.pending}</h2>
                  <button class="btn btn-warning btn-sm btn-circle" onClick={() => navigate("/te-sheet?status=pending")}>
                    <i class="bi bi-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3">
          <div class="card border-0 ">
            <div class="card-body d-flex flex-column justify-content-between">
              <div>
                <h6 class="text-uppercase fw-bold text-muted mb-3">Reviewed</h6>
                <div class="d-flex justify-content-between align-items-center">
                  <h2 class="fw-bold text-info">{data?.reviewed}</h2>
                  <button class="btn btn-info btn-sm btn-circle" onClick={() => navigate("/te-sheet?status=reviewed")}>
                    <i class="bi bi-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-md-6 col-lg-3">
          <div class="card border-0 ">
            <div class="card-body d-flex flex-column justify-content-between">
              <div>
                <h6 class="text-uppercase fw-bold text-muted mb-3">Approved</h6>
                <div class="d-flex justify-content-between align-items-center">
                  <h2 class="fw-bold text-success">{data?.approved}</h2>
                  <button class="btn btn-success btn-sm btn-circle" onClick={() => navigate("/te-sheet?status=approved")}>
                    <i class="bi bi-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3">
          <div class="card border-0 ">
            <div class="card-body d-flex flex-column justify-content-between">
              <div>
                <h6 class="text-uppercase fw-bold text-muted mb-3">Issued</h6>
                <div class="d-flex justify-content-between align-items-center">
                  <h2 class="fw-bold text-primary">{data?.issued}</h2>
                  <button class="btn btn-primary btn-sm btn-circle" onClick={() => navigate("/te-sheet?status=issued")}>
                    <i class="bi bi-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row ">
        <h3 className="text-primary">TE Report Status</h3>
        
        <div class="col-md-6 col-lg-3">
          <div
            class="card border-0 "
            style={{ background: "linear-gradient(45deg, #ff9800, #ffc107)" }}
          >
            <div class="card-body d-flex flex-column justify-content-between">
              <div>
                <h6 class="text-uppercase fw-bold text-white mb-3">Pending</h6>
                <div class="d-flex justify-content-between align-items-center">
                  <h2 class="fw-bold text-white">{teReport?.pending}</h2>
                  <button class="btn btn-sm btn-circle">
                    <i class="bi bi-arrow-right text-white fs-2 text-bolder"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3">
          <div
            class="card border-0 "
            style={{ background: "linear-gradient(45deg, #1f6c22, #3fd747)" }}
          >
            <div class="card-body d-flex flex-column justify-content-between">
              <div>
                <h6 class="text-uppercase fw-bold text-white mb-3">Approved</h6>
                <div class="d-flex justify-content-between align-items-center">
                  <h2 class="fw-bold text-white">{teReport?.approved}</h2>
                  <button class="btn btn-sm btn-circle">
                    <i class="bi bi-arrow-right text-white fs-2 text-bolder"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3">
          <div
            class="card border-0 "
            style={{ background: "linear-gradient(45deg, #8713d1, #663f7f)" }}
          >
            <div class="card-body d-flex flex-column justify-content-between">
              <div>
                <h6 class="text-uppercase fw-bold text-white mb-3">Issued</h6>
                <div class="d-flex justify-content-between align-items-center">
                  <h2 class="fw-bold text-white">{teReport?.issued}</h2>
                  <button class="btn btn-sm btn-circle">
                    <i class="bi bi-arrow-right text-white fs-2 text-bolder"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3">
          <div
            class="card border-0 "
            style={{ background: "linear-gradient(45deg, #2196f3, #64b5f6)" }}
          >
            <div class="card-body d-flex flex-column justify-content-between">
              <div>
                <h6 class="text-uppercase fw-bold text-white mb-3">Total</h6>
                <div class="d-flex justify-content-between align-items-center">
                  <h2 class="fw-bold text-white">{teReport?.total}</h2>
                  <button class="btn btn-sm btn-circle">
                    <i class="bi bi-arrow-right text-white fs-2 text-bolder"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="row">
        <h3 className="text-primary">Audit Circular Status</h3>
        
        <div class="col-md-6 col-lg-3">
          <div class="card border-0 ">
            <div class="card-body d-flex flex-column justify-content-between">
              <div>
                <h6 class="text-uppercase fw-bold text-muted mb-3">Pending</h6>
                <div class="d-flex justify-content-between align-items-center">
                  <h2 class="fw-bold text-warning">{audit?.pending}</h2>
                  <button
                    class="btn btn-warning btn-sm btn-circle"
                    onClick={() => navigate("/audit?status=pending")}
                  >
                    <i class="bi bi-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3">
          <div class="card border-0 ">
            <div class="card-body d-flex flex-column justify-content-between">
              <div>
                <h6 class="text-uppercase fw-bold text-muted mb-3">Approved</h6>
                <div class="d-flex justify-content-between align-items-center">
                  <h2 class="fw-bold text-success">{audit?.approved}</h2>
                  <button
                    class="btn btn-success btn-sm btn-circle"
                    onClick={() => navigate("/audit?status=approved")}
                  >
                    <i class="bi bi-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3">
          <div class="card border-0 ">
            <div class="card-body d-flex flex-column justify-content-between">
              <div>
                <h6 class="text-uppercase fw-bold text-muted mb-3">Rejected</h6>
                <div class="d-flex justify-content-between align-items-center">
                  <h2 class="fw-bold text-danger">{audit?.rejected}</h2>
                  <button
                    class="btn btn-danger btn-sm btn-circle"
                    onClick={() => navigate("/audit?status=rejected")}
                  >
                    <i class="bi bi-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3">
          <div class="card border-0">
            <div class="card-body d-flex flex-column justify-content-between">
              <div>
                <h6 class="text-uppercase fw-bold text-muted mb-3">Total</h6>
                <div class="d-flex justify-content-between align-items-center">
                  <h2 class="fw-bold text-primary">{audit?.total}</h2>
                  <button
                    className="btn btn-primary btn-sm btn-circle"
                    onClick={() => navigate("/audit?status=")}
                  >
                    <i className="fa-solid fa-arrow-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <h3 className="text-primary">Audit Report Status</h3>
        
        <div class="col-md-6 col-lg-3">
          <div
            class="card border-0 "
            style={{ background: "linear-gradient(45deg, #ff9800, #ffc107)" }}
          >
            <div class="card-body d-flex flex-column justify-content-between">
              <div>
                <h6 class="text-uppercase fw-bold text-white mb-3">Pending</h6>
                <div class="d-flex justify-content-between align-items-center">
                  <h2 class="fw-bold text-white">{auditReport?.pending}</h2>
                  <button class="btn btn-sm btn-circle">
                    <i class="bi bi-arrow-right text-white fs-2 text-bolder"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3">
          <div
            class="card border-0 "
            style={{ background: "linear-gradient(45deg, #1f6c22, #3fd747)" }}
          >
            <div class="card-body d-flex flex-column justify-content-between">
              <div>
                <h6 class="text-uppercase fw-bold text-white mb-3">Approved</h6>
                <div class="d-flex justify-content-between align-items-center">
                  <h2 class="fw-bold text-white">{auditReport?.approved}</h2>
                  <button class="btn btn-sm btn-circle">
                    <i class="bi bi-arrow-right text-white fs-2 text-bolder"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3">
          <div
            class="card border-0 "
            style={{ background: "linear-gradient(45deg, #f44336, #e57373)" }}
          >
            <div class="card-body d-flex flex-column justify-content-between">
              <div>
                <h6 class="text-uppercase fw-bold text-white mb-3">Rejected</h6>
                <div class="d-flex justify-content-between align-items-center">
                  <h2 class="fw-bold text-white">{auditReport?.rejected}</h2>
                  <button class="btn btn-sm btn-circle">
                    <i class="bi bi-arrow-right text-white fs-2 text-bolder"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-3">
          <div
            class="card border-0 "
            style={{ background: "linear-gradient(45deg, #2196f3, #64b5f6)" }}
          >
            <div class="card-body d-flex flex-column justify-content-between">
              <div>
                <h6 class="text-uppercase fw-bold text-white mb-3">Total</h6>
                <div class="d-flex justify-content-between align-items-center">
                  <h2 class="fw-bold text-white">{auditReport?.total}</h2>
                  <button class="btn btn-sm btn-circle">
                    <i class="bi bi-arrow-right text-white fs-2 text-bolder"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default Home;
